// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".eventsWrapper--A-SCUC7o {\n  padding: 0 12px;\n  flex: 1;\n  overflow: hidden;\n  overflow-y: auto;\n}\n\n.brickList--3ybkvsp6 {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"eventsWrapper": "eventsWrapper--A-SCUC7o",
	"brickList": "brickList--3ybkvsp6"
};
export default ___CSS_LOADER_EXPORT___;
